define('view/controller/review/ReviewLayoutView',['require','view/controller/review/ReviewListView','view/controller/review/ReviewFormView','lib/view/LayoutView','model/ReviewModel'],function (require) {

    var ReviewListView = require('view/controller/review/ReviewListView');
    var ReviewFormView = require('view/controller/review/ReviewFormView');
    var LayoutView = require('lib/view/LayoutView');
    var ReviewModel = require('model/ReviewModel');

    /**
     * Reviews composite view (images container)
     *
     * @class ReviewsIndexView
     */
    return LayoutView.extend({

        template: '#reviews_view',

        regions: {
            reviewsList: '#sb_reviews_list_container',
            reviewsForm: '#sb_reviews_add_container'
        },
        childEvents: {
            'saved': 'onReviewSaved'
        },
        _reviewModel: null,
        _reviewClientModel: null,
        _isCollectionReady : false,

        initialize : function () {
            var instance = this;
            this._reviewModel = new ReviewModel();
            this._reviewClientModel = this.getOption('reviewClientModel');

            this.listenTo(this.collection, 'sync', function (event) {
                if(!instance._isCollectionReady) {
                    instance._isCollectionReady = true;
                    instance.onCollectionReady(event);
                }
            });
        },

        onCollectionReady : function(){
            var instance = this;

            this.listenTo(this._reviewClientModel, 'change', function () {
                //console.log(instance._reviewClientModel.get('logged_in'));
                if(instance._reviewClientModel.get('logged_in') /*&& !this.collection.withUserLike()*/) {
                    this.collection.reloadPage(); //load user likes
                }
            });
        },

        onBeforeShow: function() {
            var hideAddReview = Config.getInstance().getOption('hide_add_reviews');

            this.showChildView('reviewsList', new ReviewListView({
                collection : this.collection,
                reviewModel : this._reviewModel
            }));

            if(!hideAddReview){
                this.showChildView('reviewsForm', this._getFormView());
            }
        },

        _getFormView: function () {
            return new ReviewFormView({
                model: this._reviewModel,
                reviewsCollection: this.collection,
                reviewClientModel: this.getOption('reviewClientModel'),
                clientModel: this.getOption('clientModel')
            });
        },

        onReviewSaved: function () {
            this.collection.setPage(1);
            this.collection.add(this._reviewModel);
            // do not need it. we return real id
            //this.collection.reloadPage(); //We need to reload the page because we do not have a real feedback id.

            this._reviewModel = new ReviewModel();
            this.showChildView('reviewsForm', this._getFormView());
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'reviews'
            });
        }

    });

});
